import { render, staticRenderFns } from "./SmsSetting.vue?vue&type=template&id=cecd4b36&scoped=true&"
import script from "./SmsSetting.vue?vue&type=script&lang=js&"
export * from "./SmsSetting.vue?vue&type=script&lang=js&"
import style0 from "./SmsSetting.vue?vue&type=style&index=0&id=cecd4b36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cecd4b36",
  null
  
)

export default component.exports